import { render, staticRenderFns } from "./ChartsAside.vue?vue&type=template&id=220c03b2"
import script from "./ChartsAside.vue?vue&type=script&lang=js"
export * from "./ChartsAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports